module.exports = __webpack_public_path__ + "img/package-discount.0a8f575.png";